/* eslint react-hooks/rules-of-hooks: "warn" */
import { getHotkeyMenu, HOTKEY_TYPE, useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer, pickLayer }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    const layer = pickLayer || activeLayer;
    const disabled = !layer;

    if (disabled || !activeLayer) return null;

    const layerSortData = framework.getLayerSortData(activeLayer.id);

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.layerSort),
        type: 'sort',
        childMenus: [
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.sortTop),
                disabled: layerSortData.operate.disableUp,
                type: HOTKEY_TYPE.sortTop,
                desc: getHotkeyMenu(HOTKEY_TYPE.sortTop),
                onClick: () => {
                    framework.events.emit(HOTKEY_TYPE.sortTop);
                },
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.sortBottom),
                disabled: layerSortData.operate.disableDown,
                type: HOTKEY_TYPE.sortBottom,
                desc: getHotkeyMenu(HOTKEY_TYPE.sortBottom),
                onClick: () => {
                    framework.events.emit(HOTKEY_TYPE.sortBottom);
                },
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.sortUp),
                disabled: layerSortData.operate.disableUp,
                type: HOTKEY_TYPE.sortUp,
                desc: getHotkeyMenu(HOTKEY_TYPE.sortUp),
                onClick: () => {
                    framework.events.emit(HOTKEY_TYPE.sortUp);
                },
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.sortDown),
                disabled: layerSortData.operate.disableDown,
                type: HOTKEY_TYPE.sortDown,
                desc: getHotkeyMenu(HOTKEY_TYPE.sortDown),
                onClick: () => {
                    framework.events.emit(HOTKEY_TYPE.sortDown);
                },
            },
        ],
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 3,
    sort: 1,
    render,
} as IExportContextMenuItem;
